export default "__VITE_ASSET__3fd3bbad__"